import axios from "axios";

export const PhoneNumber = (phoneNo) => {
  return phoneNo?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4");
};

export const PhoneNumberInversion = (phoneNo) => {
  return phoneNo?.replaceAll("-", "");
};

export const CheckIfImageExists = async (path) => {
  return axios
    .get(path)
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};
